import React, { useState } from 'react';

const Signup = (props) => {

    const [email, setEmail] = useState('');
    const [status, setStatus] = useState({ type: '', message: '' });
    const [loading, setLoading] = useState(false);

    const getErrorMessage = (response, data) => {
        if (response.status === 409) {
            return 'This email is already subscribed.';
        }

        if (typeof data?.message === 'string') {
            return data.message;
        }

        if (typeof data?.errors === 'string') {
            return data.errors;
        }

        return 'Something went wrong. Please try again.';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: '', message: '' });

        const API_URL = '/wp-json/frm/v2/entries';
        const apiKey = '6EPD-J73B-EF0H-06PF';
        const authHeader = 'Basic ' + btoa(apiKey + ':x');

        try {
            const response = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader
                },
                body: JSON.stringify({
                    form_id: 2,
                    '7': email,
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                setStatus({
                    type: 'error',
                    message: getErrorMessage(response, data)
                });
                return;
            }

            setStatus({
                type: 'success',
                message: 'Success! You have been subscribed.'
            });
            setEmail('');
        } catch (error) {
            setStatus({
                type: 'error',
                message: 'Failed to connect to the server.'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit} className="input-container">
                <input
                    type="email"
                    placeholder="Your email address..."
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button className="button button-dark" type="submit"><i className={"far " + (loading ? 'fa-loader fa-spin' : 'fa-arrow-right')}></i><span className="sr-only">Submit</span></button>

                {status.message && (
                    <div className="input-message">
                        {status.message}
                    </div>
                )}

            </form>

        </>

    );
}

export default Signup;